import type {
  NotificationItem,
  NotificationsApiAdapter,
} from "../../common/utils/useNotifications";
import { client } from "../api-client";

const managementNotificationsAdapter: NotificationsApiAdapter = {
  async fetchNotifications({ ordering, perPage }) {
    const response = await client.apiV1ManagementNotificationsList(
      undefined,
      undefined,
      ordering,
      perPage
    );
    return { data: { results: response.data.results as unknown as NotificationItem[] } };
  },

  async fetchUnreadCount() {
    const response = await client.apiV1ManagementMeRetrieve();
    return response.data.unread_notifications ?? 0;
  },

  async markAsRead(id) {
    return client.apiV1ManagementNotificationsMarkAsReadPartialUpdate(id);
  },

  async markAllAsRead(id) {
    return client.apiV1ManagementNotificationsMarkAllAsReadPartialUpdate(id);
  },

  async deleteNotification(id) {
    return client.apiV1ManagementNotificationsDestroy(id);
  },
};

export { managementNotificationsAdapter };
